export class ResetPassword {
    username: string;
    email: string;
    password: string;
    confirmpassword: string;
    token: string;
}
